<template>
  <DefaultModal
    v-if="
      (company.address && company.postalcode && company.city) || isTreatwellUser
    "
    @close="$emit('close')"
  />
  <AddressModal
    v-else
    @close="$emit('close')"
  />
</template>

<script
  setup
  lang="ts"
>
import { useGtm } from '@gtm-support/vue-gtm';
import { storeToRefs } from 'pinia';

import { onBeforeUnmount, watch } from 'vue';
import { updateDataLayer } from '@/helpers/gtm';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';
import AddressModal from './Address.vue';
import DefaultModal from './Default.vue';

const { company } = useCompanyStore();
const { isSubscribed } = storeToRefs(useCompanyStore());
const gtm = useGtm();
const { isTreatwellUser } = storeToRefs(useCompanyStore());

const { getTreatwellStatus } = useTreatwellStore();

defineEmits(['close']);

watch(
  isSubscribed,
  (newVal) => {
    if (newVal) {
      // IMPORTANT! Track subscription conversion
      updateDataLayer().then(() => {
        if (gtm) {
          gtm.trackEvent({ event: 'subscription' });
        }
      });
    }
  },
  { immediate: true },
);
onBeforeUnmount(() => {
  getTreatwellStatus();
});
</script>
